// @flow
import { fork } from 'redux-saga/effects';
import statsSaga from './channelStatsSaga';

export default function*(): Generator<*, *, *> {
  yield fork(statsSaga);
}



// WEBPACK FOOTER //
// ./src/containers/channels/saga.js